import React                from 'react';
import { FormattedMessage } from 'react-intl';

interface FormattedMessageWrapperProps {
  id?: string;
  values?: Record<string, string | number | boolean | null | undefined>;
}

const FormattedMessageWrapper: React.FC<FormattedMessageWrapperProps> = (props) => {
	const {
		id,
		values,
	} = props;

  if (typeof id !== 'string') {
		if (import.meta.env.DEV) {
			console.warn('FormattedMessageWrapper: Wrong or missing id', id);
		}

    return <>{id}</>;
  }

	return (
		<FormattedMessage
			id={id}
			values={values}
			defaultMessage={id}
		/>
	);
};

export default FormattedMessageWrapper;